import { IncidentsWebComponent } from './component/IncidentsWebComponent';
import { WEB_COMPONENT_WIDGET_INCIDENTS } from '../webcomponents.constants';

export { IncidentsWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_INCIDENTS, IncidentsWebComponent);
